import { Dispatch, SetStateAction } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';
import { List } from '@atom/mui';
import { WorkOrderResult } from '@atom/types/search';
import { getWorkIconByStatusId } from '@atom/utilities/iconUtilities';
import { highlightedText } from '@atom/utilities/textDisplayUtilities';

import classes from './searchBar.module.css';

const { ListItemButton, ListItemText } = List;

const styles = {
  list: {
    padding: 0,
  },
  listItem: {
    paddingLeft: '1rem',
  },
  primaryTextStyle: {
    fontWeight: 'none',
  },
};

interface Props {
  query: string;
  result: WorkOrderResult;
  setFocused: Dispatch<SetStateAction<boolean>>;
}

const WorkResultItem = ({ query, result, setFocused }: Props) => {
  const [, { navigate }] = useNavigation();
  const icon = getWorkIconByStatusId(result.statusId);
  const assetName = highlightedText(query, result.name);

  const handleNavigate = () => {
    navigate(`/workOrders/${result.id}`);
    setFocused(false);
  };

  return (
    <ListItemButton
      key={result.id}
      onClick={handleNavigate}
      style={styles.listItem}
    >
      <div className={classes.workOrderIconContainer}>{icon}</div>
      <ListItemText
        primary={assetName}
        primaryTextStyle={styles.primaryTextStyle}
      />
    </ListItemButton>
  );
};

export default WorkResultItem;
